import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody, Text, Button, ModalFooter, useToast } from '@chakra-ui/react'
import Compressor from 'compressorjs'
import { FixedCropper, ImageRestriction, CircleStencil } from 'react-advanced-cropper'
import 'react-advanced-cropper/dist/style.css'
import { useRef, useState } from 'react'

const dataUrlToFile = (url : string, fileName : string) => {
    // Split the URL into the media type and data parts
    const [mediaType, data] = url.split(',');
  
    // Extract the MIME type using a regular expression
    const mimeMatch = mediaType.match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : '';
  
    // Decode the Base64-encoded data part
    const byteString = atob(data);
  
    // Create a Uint8Array to hold the binary data
    const n = byteString.length;
    const arr = new Uint8Array(n);
  
    // Convert the binary data to the Uint8Array
    for (let i = 0; i < n; i++) {
      arr[i] = byteString.charCodeAt(i);
    }
  
    // Create and return a File object
    return new File([arr], fileName, { type: mime });
  };
  
  

const PROFILE_IMAGE_SIZE = 600

const ProfileCropModal = ({
  image,
  isOpen,
  onClose,
  onSave,
  isLoading,
}: {
  image: string
  isOpen: boolean
  onClose: () => void
  onSave: (v: File | null) => void
  isLoading: boolean
}) => {
  const cropperRef = useRef<any>(null)
  const [isCompressing, setIsCompressing] = useState(false)
  const toast = useToast()

  const onCrop = async () => {
    const cropper = cropperRef.current
    if (!cropper) return

    // getCanvas() returns null when the cropper's image isn't ready yet (the
    // underlying <img> hasn't finished decoding). This happens on iOS/Mobile
    // Safari when the user taps Save before the image loads — calling
    // toDataURL() on a null canvas crashes. Bail out gracefully instead.
    const canvas = cropper.getCanvas({ width: PROFILE_IMAGE_SIZE, height: PROFILE_IMAGE_SIZE })
    if (!canvas) {
      console.warn('ProfileCropModal: cropper canvas not ready — image may still be loading')
      toast({
        title: 'Image still loading',
        description: 'Please wait a moment and try again.',
        status: 'info',
        duration: 3000,
        isClosable: true,
      })
      return
    }

    const finalImage = dataUrlToFile(canvas.toDataURL(), 'profile.png')

    setIsCompressing(true)
    try {
      const compressedBlob = await new Promise<Blob>((resolve, reject) => {
        new Compressor(finalImage, {
          quality: 0.6,
          maxWidth: PROFILE_IMAGE_SIZE,
          maxHeight: PROFILE_IMAGE_SIZE,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result)
          },
          error(err) {
            reject(err)
          },
        })
      })
      const compressedFile = new File([compressedBlob], 'profile.jpg', {
        type: 'image/jpeg',
      })
      onSave(compressedFile)
    } catch (error) {
      console.error('Compression failed, saving uncompressed:', error)
      onSave(finalImage)
    } finally {
      setIsCompressing(false)
    }
  }


    
    return <>
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody p='0'>
                    
                    <Text variant='title' fontSize='2xl' fontWeight='500' mb='20px'>
                        Center your profile picture
                    </Text>
                    <FixedCropper
                        style={{ height: '440px', width: '100%' }}
                        stencilComponent={CircleStencil}
                        stencilSize={{
                            width: 400,
                            height: 400
                        }}
                        stencilProps={{
                            aspectRatio: 1/1,
                            movable: false,
                        }}
                        imageRestriction={ImageRestriction.stencil}
                        ref={cropperRef}
                        src={image}
                    />

                </ModalBody>
                <ModalFooter>
                    <Button variant="heavy" size="sm" isLoading={isLoading || isCompressing} onClick={() => onCrop()}>
                    Save
                  </Button>
                </ModalFooter>
            </ModalContent>
    </Modal>
    
    </>

}

export default ProfileCropModal;